import {
  ResetPasswordDocument,
  ResetPasswordMutation,
  ResetPasswordMutationVariables,
  ChangePasswordDocument,
  ChangePasswordMutation,
  ChangePasswordMutationVariables,
  CurrentUserDocument,
  CurrentUserQuery,
  CurrentUserQueryVariables,
  RevokeTokenDocument,
  RevokeTokenMutation,
  RevokeTokenMutationVariables,
  UserFragment,
} from '../types';
import { client, publicClient } from '../../client';

// Roles: [Shared]
// Revoke a token
// This can be used as logout -> all:false (def) -> Logout from current device
// If you pass the variable all:true then it will revoke all tokens -> Logout from all devices
export async function revokeToken(variables: RevokeTokenMutationVariables): Promise<Readonly<string | undefined>> {
  try {
    const result = await client.mutate<RevokeTokenMutation, RevokeTokenMutationVariables>({
      mutation: RevokeTokenDocument,
      variables,
    });
    return result.data.revoke_token.message;
  } catch (error) {
    throw Error(error);
  }
}

// Roles: [Shared]
// Change the password
// TODO: It's public for now but requires authentication
export async function changePassword(variables: ChangePasswordMutationVariables): Promise<Readonly<string | undefined>> {
  try {
    const result = await publicClient.mutate<ChangePasswordMutation, ChangePasswordMutationVariables>({
      mutation: ChangePasswordDocument,
      variables,
    });
    return result.data.change_password.message;
  } catch (error) {
    throw Error(error);
  }
}

/*
Available on authenticated roles.
Provides the current logged in user.
*/
export async function currentUser(): Promise<Readonly<UserFragment | undefined>> {
  try {
    const result = await client.mutate<CurrentUserQuery, CurrentUserQueryVariables>({
      mutation: CurrentUserDocument,
    });
    return result.data?.me ?? null;
  } catch (error) {
    throw Error(error);
  }
}

/*
Available on authenticated roles.
Resets the logged in user passoword with a new one.
If the user dosen't have an old password, the field old_password is required to be the same as the new_password.
*/
export async function resetPassword(variables: ResetPasswordMutationVariables): Promise<Readonly<string | undefined>> {
  try {
    const result = await client.mutate<ResetPasswordMutation, ResetPasswordMutationVariables>({
      mutation: ResetPasswordDocument,
      variables,
    });
    return result.data.reset_password.message;
  } catch (error) {
    throw Error(error);
  }
}
